export const chatComposerStyle = context => {

    return {
        padding: "8px 4px 8px 16px",
        backgroundColor: `${context.theme.backgroundColor.white}`,
        zIndex: "1",
        order: "3",
        position: "fixed",
        bottom: 0,
        flex: "none"
    };
};

export const editPreviewContainerStyle = (context, keyframes) => {

    const slideAnimation = keyframes`
    from {
        bottom: -60px
    }
    to {
        bottom: 0px
    }`;

    return {
        padding: "7px",
        backgroundColor: `${context.theme.backgroundColor.white}`,
        borderColor: `${context.theme.borderColor.primary}`,
        borderWidth: "1px 1px 1px 5px",
        borderStyle: "solid",
        color: `${context.theme.color.helpText}`,
        fontSize: "13px",
        animation: `${slideAnimation} 0.5s ease-out`,
        position: "relative",
    };
};

export const previewHeadingStyle = () => {

    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    }
}

export const previewTextStyle = () => {

    return {
        padding: "5px 0",
    }
}

export const previewCloseStyle = (img, context) => {

    return {
        width: "24px",
        height: "24px",
        borderRadius: "50%",
        cursor: "pointer",
        mask: `url(${img}) center center no-repeat`,
        backgroundColor: `${context.theme.primaryColor}`
    }
}

export const composerInputStyle = () => {

    return {
        display: "flex",
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-end",
        position: "relative",
        zIndex: "2",
        padding: "0",
        alignItems: "center"
    }
}

export const inputInnerStyle = (props, state, context) => {

    const borderRadiusVal = {
        borderRadius: "8px",
    };

    return {
        flex: "1 1 auto",
        position: "relative",
        outline: "none",
        border: `1px solid ${context.theme.borderColor.primary}`,
        backgroundColor: `${context.theme.backgroundColor.white}`,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        ...borderRadiusVal
    }
}

export const messageInputStyle = (disabled) => {

    const disabledState = (disabled) ? {
        pointerEvents: "none",
        opacity: "0.4"
    } : {};

    return {
        width: "100%",
        fontSize: "15px",
        lineHeight: "20px",
        fontWeight: "400",
        padding: "8px 72px 8px 12px",
        outline: "none",
        overflowX: "hidden",
        overflowY: "auto",
        position: "relative",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        zIndex: "1",
        minHeight: "22px",
        maxHeight: "100px",
        userSelect: "text",
        backgroundColor: "#fff",
        borderRadius: "4px",
        ...disabledState,
        '&:empty:before': {
            content: "attr(placeholder)",
            color: "rgb(153, 153, 153)",
            pointerEvents: "none",
            display: "block", /* For Firefox */
        }
    }
}

export const inputStickyStyle = (disabled, attachments, context) => {

    const disabledState = (disabled) ? {
        pointerEvents: "none",
    } : {};

    const flexDirectionProp = (attachments === null) ? {
        flexDirection: "row-reverse",
    } : {};

    return {
        position: "absolute",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        margin: "0px",
        justifyContent: "space-between",
        ...flexDirectionProp,
        ...disabledState,
        '&:empty:before': {
            pointerEvents: "none",
        }
    }
}

export const stickyAttachmentStyle = () => {

    return {
        display: "flex",
        width: "auto",
        marginRight: "5px",
        alignItems: "center"
    }
}

export const attachmentIconStyle = () => {

    return {
        margin: "auto 0",
        width: "24px",
        height: "20px",
        cursor: "pointer",
    }
}

export const filePickerStyle = (state) => {

    const active = (state.showFilePicker) ? {
        width: "calc(100% - 20px)",
        opacity: "1",
    } : {};

    return {
        width: "0",
        height: "100%",
        borderRadius: "8px",
        overflow: "hidden",
        zIndex: "1",
        opacity: "0",
        // transition: "width 0.5s linear",
        ...active,
    }
}

export const fileListStyle = () => {

    return {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 16px",
    }
}

export const fileItemStyle = (img, context) => {

    return {
        height: "24px",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 16px 0 0",
        color: "#E1E3EA",
        " > i": {
            width: "24px",
            height: "24px",
            display: "inline-block",
            mask: `url(${img}) center center no-repeat`,
            backgroundColor: "#E1E3EA"
        },
        ' > input': {
            display: "none",
        },
    }
}

export const stickyAttachButtonStyle = () => {

    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        width: "24px",
        color: "#E1E3EA"
    }
}

export const stickyButtonStyle = (state) => {

    const active = {
        display: "flex",
    };

    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        width: "auto",
        ...active
    }
}

export const emojiButtonStyle = (img, context) => {

    return {
        height: "50px",
        width: "40px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 0 0 16px",
        "i": {
            width: "30px",
            height: "30px",
            display: "inline-block",
            mask: `url(${img}) center center no-repeat`,
            backgroundColor: `${context.theme.secondaryTextColor}`
        }
    }
}

export const sendButtonStyle = () => {

    return {
        height: "24px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 0 0 16px",
        color: "#E1E3EA"
    }
}

export const reactionBtnStyle = () => {

    return {
        cursor: "pointer",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 0 0 16px",
    }
}

export const stickerBtnStyle = (img, context) => {

    return {
        cursor: "pointer",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 0 0 16px",
        "i": {
            width: "24px",
            height: "24px",
            display: "inline-block",
            mask: `url(${img}) center center no-repeat`,
            backgroundColor: `${context.theme.secondaryTextColor}`
        }
    }
}